// @utils/api/back-office/language-and-config/use-get-language-publications.ts
import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { BaseError, BaseResponse } from '@utils/types/shared/base';

export type Publication = {
  id: number;
  organization_id: number;
  organization_name: string;
};

export type PublicationResponse = BaseResponse<
  Publication[] | Publication | null | undefined
>;

export const useGetLanguageAndConfigPublication = (
  languageId: number,
  options?: UseQueryOptions<
    PublicationResponse,
    AxiosError<BaseError>,
    Publication[]
  >
) => {
  const fetchPublications = async () => {
    const { languageAndConfigPublicationByLanguageId } = GET_URL_NEW();
    const url = languageAndConfigPublicationByLanguageId(languageId);
    const { data } = await Axios.get<PublicationResponse>(url);
    return data;
  };

  return useQuery<PublicationResponse, AxiosError<BaseError>, Publication[]>(
    ['languageAndConfigPublication', languageId],
    fetchPublications,
    {
      enabled: Number.isFinite(languageId) && languageId > 0,
      useErrorBoundary: false,
      select: data => {
        const r = data?.result;
        if (Array.isArray(r)) return r;
        if (r && typeof r === 'object') return [r as Publication];
        return [];
      },
      ...options
    }
  );
};
